import React, { useMemo } from 'react';
import { withNativeProps } from '../../utils/native-props';
import { mergeProps } from '../../utils/with-default-props';
import Popup from '../popup';
import ShareChannelPicker from '../share-channel-picker';
import { normalizeChannels } from './message-share-channel';
var classPrefix = 'nib-message-sharing';
/** 动画入场持续时长（单位：毫秒） */

var ENTER_TIMEOUT = 300;
/** 动画离场持续时长（单位：毫秒） */

var EXIT_TIMEOUT = 200;
/** 图文消息分享浮层背景色 */

export var OVERLAY_BGCOLOR = 'rgba(20, 24, 34, 0.6)';
/** 渠道选择区域背景色 */

export var CHANNEL_BGCOLOR = '#FFFFFF';
var defaultProps = {
  visible: false,
  tips: '分享到',
  channels: [],
  cancelText: '取消',
  closeOnMaskClick: false,
  closeOnChannelClick: true,
  autoSafeArea: true
};
export var MessageSharing = function MessageSharing(p) {
  var props = mergeProps(defaultProps, p);
  var channels = useMemo(function () {
    return normalizeChannels(props.channels);
  }, [props.channels]);
  return withNativeProps(props, /*#__PURE__*/React.createElement(Popup, {
    className: classPrefix,
    visible: props.visible,
    position: "bottom",
    enterTimeout: ENTER_TIMEOUT,
    exitTimeout: EXIT_TIMEOUT,
    getContainer: null,
    onMaskClick: props.closeOnMaskClick ? props.onClose : undefined,
    afterClose: props.afterClose,
    afterShow: props.afterShow,
    destroyOnClose: true,
    maskStyle: {
      background: OVERLAY_BGCOLOR
    }
  }, /*#__PURE__*/React.createElement(ShareChannelPicker, {
    title: props.tips,
    channels: channels,
    cancelButton: Boolean(props.cancelText),
    cancelText: props.cancelText,
    autoSafeArea: props.autoSafeArea,
    onChannelClick: function onChannelClick(channel) {
      var _a, _b;

      (_a = props.onChannelClick) === null || _a === void 0 ? void 0 : _a.call(props, {
        channel: channel
      });

      if (props.closeOnChannelClick) {
        (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
      }
    },
    onCancelClick: props.onClose,
    style: {
      '--background-color': CHANNEL_BGCOLOR
    }
  })));
};